module.exports = __webpack_public_path__ + "img/ad-home-md.0d66f95d.jpg";